import { Injectable } from '@angular/core';
import { ScanOutcome } from './barcode-scanner.models';

@Injectable({
  providedIn: 'root',
})
export class BarcodeScannerSoundService {
  private audioContext: AudioContext | null = null;

  unlock(): void {
    const context = this.getAudioContext();

    if (context?.state === 'suspended') {
      void context.resume();
    }
  }

  play(outcome: ScanOutcome): void {
    const context = this.getAudioContext();

    if (!context) {
      return;
    }

    if (context.state === 'suspended') {
      void context.resume();
    }

    const frequencies = this.frequenciesForOutcome(outcome);
    frequencies.forEach((frequency, index) => {
      this.playTone(context, frequency, 0.06, index * 0.08);
    });
  }

  private getAudioContext(): AudioContext | null {
    if (this.audioContext) {
      return this.audioContext;
    }

    const audioWindow = window as unknown as { AudioContext?: typeof AudioContext; webkitAudioContext?: typeof AudioContext };
    const AudioContextConstructor = audioWindow.AudioContext || audioWindow.webkitAudioContext;

    if (!AudioContextConstructor) {
      return null;
    }

    this.audioContext = new AudioContextConstructor();
    return this.audioContext;
  }

  private frequenciesForOutcome(outcome: ScanOutcome): number[] {
    switch (outcome) {
      case 'success':
        return [660, 880];
      case 'duplicate':
        return [440, 440];
      case 'warning':
        return [520, 360];
      case 'error':
        return [220, 180];
      case 'info':
      default:
        return [520];
    }
  }

  private playTone(context: AudioContext, frequency: number, duration: number, offset: number): void {
    const oscillator = context.createOscillator();
    const gain = context.createGain();
    const startsAt = context.currentTime + offset;

    oscillator.frequency.value = frequency;
    oscillator.type = 'sine';
    gain.gain.setValueAtTime(0.001, startsAt);
    gain.gain.exponentialRampToValueAtTime(0.08, startsAt + 0.01);
    gain.gain.exponentialRampToValueAtTime(0.001, startsAt + duration);
    oscillator.connect(gain);
    gain.connect(context.destination);
    oscillator.start(startsAt);
    oscillator.stop(startsAt + duration + 0.02);
  }
}
